import React from 'react'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Group from 'components/utils/Group'
import OfferPageIntroInclusionItem from './OfferPageIntroInclusionItem'

interface Props {
  tileInclusionsList: Array<App.TileInclusion>;
  title?: string
}

function OfferPageIntroInclusions(props: Props) {
  const {
    tileInclusionsList,
    title = 'Your handpicked inclusions:',
  } = props

  return (
    <Group direction="vertical" gap={8}>
      <BodyText variant="large" weight="bold">{title}</BodyText>
      <div>
        {tileInclusionsList.map(inclusion => (
          <OfferPageIntroInclusionItem key={inclusion.text} inclusion={inclusion} />
        ))}
      </div>
    </Group>
  )
}

export default OfferPageIntroInclusions
